import React, { useEffect, useState } from 'react'
import CloseSVG from '../../../../assets/svg/close.svg'
import Button from '../../../button'
import { useForm } from 'react-hook-form'
import AsyncSelect from 'react-select/async'
import Modal from '../../modal'
import FormSelectEmployee from '../../../employees/form-select-employee'
import {
  useAddPerformanceEvaluation,
  useGetPerformanceOnboardingWorkflows,
} from '../../../../redux/human-resources/hook/performance'
import FormInput from '../../../form-input'
import { formValidation } from '../../../../utils/functions'
import FormSelect from '../../../form-select'
import FormTextArea from '../../../form-textarea'
import AddPerformanceWorkflow from './add-workflow'
import { store } from '../../../../redux'
import { setAlert } from '../../../../redux/components/components-slice'

function EvaluatePerformance({
  isOpen,
  closeModal,
  title,
  loadOptions,
  type,
  addPerformanceEvaluation,
  addPerformanceEvaluationLoading,
  pipData,
}) {
  const {
    register,
    handleSubmit,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  })
  const [employee, setEmployee] = useState()
  const [employeeName, setEmployeeName] = useState()

  const [workflowId, setWorkflowId] = useState()

  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [reviewerComment, setReviewerComment] = useState()
  const [trainingRequirement, setTrainingRequirement] = useState('')

  const [showAddWorkflow, setShowAddWorkflow] = useState(null)
  const [workflowData, setWorkflowData] = useState(null)
  const [subWorkflow, setSubWorkflow] = useState([])

  const { data: workflowOptions, isLoading: performanceIsLoading } =
    useGetPerformanceOnboardingWorkflows(1000, 1, '')

  useEffect(() => {
    if (pipData) {
      if (pipData?.id) {
        setStartDate(pipData?.start_date)
        setEndDate(pipData?.end_date)
        setEmployee(pipData?.employee_id)
        setEmployeeName(pipData?.first_name + ' ' + pipData?.last_name)
      }
    }
  }, [pipData])

  useEffect(() => {
    if (!workflowOptions && !performanceIsLoading) {
      store.dispatch(
        setAlert(
          true,
          'warning',
          'No workflow saved. Add performance workflow to evaluate performance'
        )
      )
    }
  }, [workflowOptions, performanceIsLoading])

  const changeCriteria = (value) => {
    let index = workflowOptions.findIndex((item) => item.value == value)
    if (index !== -1) {
      setWorkflowId(workflowOptions[index].id)
      let subData = []
      if (
        workflowOptions[index].criteria &&
        workflowOptions[index].criteria.length > 0
      ) {
        workflowOptions[index].criteria.forEach((item) => {
          let newCriteria = {
            name: item.name,
            max_grade: item.max_grade,
            grade: '',
          }
          subData.push(newCriteria)
        })
        setSubWorkflow(subData)
      }
    }
  }

  const submitForm = async () => {
    let payload = {
      employee_id: employee,
      workflow_id: workflowId,
      evaluation_start: startDate,
      evaluation_end: endDate,
      reviewer_comment: reviewerComment,
      training_requirement: trainingRequirement,
      result: subWorkflow,
    }
    if (type) {
      payload.type = type
    }
    addPerformanceEvaluation(payload).then(() => {
      closeModal()
    })
  }

  return (
    <>
      {showAddWorkflow ? (
        <AddPerformanceWorkflow
          isOpen={showAddWorkflow}
          closeModal={() => setShowAddWorkflow(false)}
          workflowData={workflowData}
          title={'Add Performance Workflow'}
          buttonText={'Save Workflow'}
        />
      ) : null}
      <Modal
        scrollable={true}
        className='!max-w-[600px] !min-w-[600px] !rounded-none'
        isOpen={isOpen}
        centered={true}
      >
        <div className='flex flex-col overflow-auto'>
          <form className='form pb-6'>
            <div className='pl-6 pr-6 pt-4'>
              <div className='flex flex-row justify-between items-center'>
                <span className='header-4'>{title}</span>
                <div className='cursor-pointer' onClick={() => closeModal()}>
                  <img src={CloseSVG} alt='close' />
                </div>
              </div>
            </div>
            <hr className='divider mb-2' />
            <div className='flex flex-col gap-2.5 max-h-fit mx-8'>
              {!loadOptions && (
                <div className='border bg-highlight p-2 rounded-md'>
                  <FormSelectEmployee
                    label={'Select employee to evaluate'}
                    name='employee'
                    readOnly={pipData}
                    placeholder='Type to select Employee'
                    value={employee}
                    empName={employeeName}
                    setEmployee={setEmployee}
                  />
                </div>
              )}

              {loadOptions && (
                <AsyncSelect
                  isMulti={false}
                  cacheOptions
                  defaultOptions
                  className='text-[13px]'
                  placeholder={'Select employee to evaluate'}
                  loadOptions={loadOptions}
                  // onChange={(options) => setEmployee(options)}
                  onChange={(option) => {
                    setEmployee(option?.value)
                    setEmployeeName(option?.label)
                  }}
                  classNamePrefix='mySelect'
                />
              )}

              <hr className='divider mb-2 mt-2' />

              <p className='text-sm text-[#000005] font-bold'>
                Evaluation Criteria
              </p>
              {workflowOptions ? (
                <div className='w-full md:w-[80%] '>
                  <FormSelect
                    value={workflowId}
                    options={workflowOptions}
                    onChange={(selected) => {
                      changeCriteria(selected)
                      setWorkflowId(selected)
                    }}
                    extraClass='!bg-white'
                    label='Select question from your saved workflow'
                  />
                </div>
              ) : (
                <div
                  onClick={() => setShowAddWorkflow(true)}
                  className='text-sm p-2 w-[270px] flex items-center justify-center cursor-pointer font-semibold rounded text-[#238B45] bg-[#F9FCF8]'
                >
                  Add Performance Workflow
                </div>
              )}

              {subWorkflow && subWorkflow.length > 0 ? (
                <div className='flex flex-col w-full text-[13px] '>
                  <div className='w-full flex items-center justify-center mb-5 text-sm font-bold text-hr-primary-1'>
                    Evaluation Criteria
                  </div>
                  {subWorkflow.map((item, index) => (
                    <div
                      className='flex flex-row w-full items-center gap-3 justify-between -mt-2'
                      key={index}
                    >
                      <div className='flex flex-col w-[60%]'>
                        <span className='text-[12px] text-color-gray'>
                          Criteria
                        </span>
                        <FormInput
                          placeholder='Review Name'
                          name={index + '_title'}
                          type='text'
                          value={item.name}
                          readOnly
                          className={'text-[13px] max-h-[30px]'}
                        />
                      </div>
                      <div className='flex flex-col w-[20%]'>
                        <span className='text-[14px] text-color-gray'>
                          Max. Grade
                        </span>
                        <FormInput
                          placeholder='Max. Grade'
                          name={index + '_max_grade'}
                          type='number'
                          readOnly
                          value={item.max_grade}
                          className={'text-[13px] max-h-[30px]'}
                        />
                      </div>
                      <div className='w-[20%]'>
                        <span className='text-[14px] text-color-gray'>
                          Grade
                        </span>
                        <FormInput
                          placeholder='Grade'
                          name={index + '_grade'}
                          type='number'
                          className={'text-[13px] max-h-[30px]'}
                          value={item.grade}
                          onInput={(e) => {
                            let value = e.target.value
                            value = value.replace(/\D/g, '')

                            if (
                              value !== '' &&
                              parseInt(value) > item.max_grade
                            ) {
                              let newArray = JSON.parse(
                                JSON.stringify(subWorkflow)
                              )

                              newArray[index].grade = ''
                              setSubWorkflow(newArray)
                            } else {
                              let newArray = JSON.parse(
                                JSON.stringify(subWorkflow)
                              )

                              newArray[index].grade = value
                              setSubWorkflow(newArray)
                            }
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <span className='w-full text-sm font-bold flex items-center justify-center'>
                  No workflow selected
                </span>
              )}

              {workflowOptions && (
                <div
                  onClick={() => setShowAddWorkflow(true)}
                  className='text-sm p-2 w-[170px] flex items-center justify-center cursor-pointer font-semibold rounded text-[#238B45] bg-[#F9FCF8]'
                >
                  Use new workflow
                </div>
              )}

              <div className='flex justify-between items-end gap-2.5'>
                <div className='w-full md:w-1/2'>
                  <FormInput
                    label='Evaluation Start Date'
                    name='start_date'
                    type='date'
                    value={startDate}
                    onInput={(e) => {
                      setStartDate(e.target.value)
                    }}
                    min={pipData ? startDate : ''}
                    max={pipData ? endDate : ''}
                    inputRef={register(formValidation('date', true))}
                    error={errors.start_date}
                    errorMessage={
                      errors.start_date && errors.start_date.message
                    }
                  />
                </div>
                <div className='w-full md:w-1/2'>
                  <FormInput
                    label='Evaluation End Date'
                    name='end_date'
                    type='date'
                    value={endDate}
                    onInput={(e) => {
                      setEndDate(e.target.value)
                    }}
                    min={startDate}
                    max={pipData ? endDate : ''}
                    inputRef={register(formValidation('date', true))}
                    error={errors.end_date}
                    errorMessage={errors.end_date && errors.end_date.message}
                  />
                </div>
              </div>
              <FormTextArea
                label={'Comment'}
                name='comment'
                placeholder={'Enter Comment'}
                type='text'
                value={reviewerComment}
                onInput={(e) => {
                  setReviewerComment(e.target.value)
                }}
              />
              {/* <FormTextArea
                         label={'Training Requirement'}
                      type='text'
                      name='training_requirement'
                      placeholder={'Enter Training requirement'}
                      value={trainingRequirement}
                      onInput={(e) => setTrainingRequirement(e.target.value)}
              /> */}

              <div className='w-full'>
                <Button
                  text={'Evaluate Performance'}
                  theme={'primary'}
                  type='button'
                  onClick={() => {
                    submitForm()
                  }}
                  loading={addPerformanceEvaluationLoading}
                />
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  )
}

export default EvaluatePerformance
